import { CALENDAR_TYPE } from '@/constants/calendar';
import { useSearchParams } from 'react-router-dom';

const CalendarTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const calendarType = searchParams.get('view') || 'calendar';

  const onTabClick = (type: string) => {
    searchParams.set('view', type);
    setSearchParams(searchParams);
  };

  return (
    <nav id='calendar-tab-mobile' className='w-full h-fit'>
      <div className='relative w-full h-8 bg-[#e3e3e3] rounded-[20px] flex items-center'>
        {CALENDAR_TYPE.map((type, index) => {
          return (
            <div
              key={index}
              className={`flex-1 h-full py-0.5 px-1 z-[2] relative gap-2 rounded-[2rem] font-medium !text-sm flex justify-center items-center cursor-pointer ${
                calendarType === type.value ? 'text-black' : 'text-[#A7A7A7]'
              }`}
              onClick={() => onTabClick(type.value)}
            >
              {type.label}
            </div>
          );
        })}
        <div
          className={`absolute top-0.5 left-0.5 w-[calc(50%-2px)] h-[calc(100%-4px)] bg-white rounded-[20px] z-[1] transition-transform duration-300 ${
            calendarType === 'list' ? 'translate-x-full' : 'translate-x-0'
          }`}
        />
      </div>
    </nav>
  );
};

export default CalendarTab;
